import { crearTabla, mostrarToast } from '@plataforma/ui';

import { extenderTrial, listarTrialsBackoffice } from '../api/backoffice.js';
import { exigirSuperAdmin } from '../guardas.js';

import {
  crearBadge,
  crearPaginacion,
  diasRestantes,
  estadoCarga,
  estadoError,
  ESTADOS_EMPRESA,
  ESTADOS_TRIAL,
  fecha,
} from './backoffice-ui.js';
import { montarShell } from './shell.js';

export async function vistaTrials(contenedorRaiz) {
  if (!exigirSuperAdmin()) return;

  const contenido = montarShell(contenedorRaiz, '/trials');
  const estadoVista = { estado: '', pagina: 1 };

  contenido.innerHTML = `
    <div class="pf-backoffice-header">
      <div>
        <h1>Trials</h1>
        <p class="pf-texto-suave">Seguimiento y extensión auditada de periodos de prueba.</p>
      </div>
    </div>
    <form class="pf-tarjeta pf-backoffice-toolbar" id="pf-filtros-trials">
      <div class="pf-campo">
        <label for="pf-trial-estado">Estado</label>
        <select id="pf-trial-estado">
          <option value="">Todos</option>
          <option value="activa">Activos</option>
          <option value="expirada">Vencidos</option>
          <option value="convertida">Convertidos</option>
        </select>
      </div>
      <button type="submit" class="pf-boton pf-boton--secundario">Filtrar</button>
    </form>
    <div id="pf-trials-tabla">${estadoCarga()}</div>
  `;

  contenido.querySelector('#pf-filtros-trials').addEventListener('submit', async (evento) => {
    evento.preventDefault();
    estadoVista.estado = contenido.querySelector('#pf-trial-estado').value;
    estadoVista.pagina = 1;
    await cargar(contenido, estadoVista);
  });

  await cargar(contenido, estadoVista);
}

async function cargar(contenido, estadoVista) {
  const destino = contenido.querySelector('#pf-trials-tabla');
  destino.innerHTML = estadoCarga();

  const { data, error, count } = await listarTrialsBackoffice(estadoVista);
  if (error) {
    destino.innerHTML = estadoError('No se pudieron cargar los trials.');
    return;
  }

  destino.innerHTML = '';
  destino.appendChild(
    crearTabla({
      filaVacia: 'No hay trials para mostrar.',
      columnas: [
        { clave: 'nombre', titulo: 'Empresa' },
        { titulo: 'Plan', render: (fila) => fila.plan?.nombre ?? '—' },
        { titulo: 'Estado empresa', render: (fila) => crearBadge(ESTADOS_EMPRESA, fila.estado) },
        { titulo: 'Trial', render: (fila) => crearBadge(ESTADOS_TRIAL, fila.trial_estado) },
        { titulo: 'Inicio', render: (fila) => fecha(fila.trial_inicia_en) },
        { titulo: 'Vencimiento', render: (fila) => fecha(fila.trial_fin_en) },
        { titulo: 'Días', render: (fila) => diasRestantes(fila.trial_fin_en) },
        {
          titulo: 'Acciones',
          render: (fila) => {
            const boton = document.createElement('button');
            boton.type = 'button';
            boton.className = 'pf-boton pf-boton--secundario pf-boton--chico';
            boton.textContent = 'Extender';
            boton.addEventListener('click', async () => {
              const dias = window.prompt(`Días a extender para ${fila.nombre}`, '7');
              if (!dias) return;
              const motivo = window.prompt('Motivo de la extensión')?.trim();
              if (!motivo) return;
              boton.disabled = true;
              const { error: errorRpc } = await extenderTrial(fila.id, Number(dias), motivo);
              boton.disabled = false;
              if (errorRpc) {
                mostrarToast(errorRpc.message ?? 'No se pudo extender el trial.', {
                  tono: 'peligro',
                });
                return;
              }
              mostrarToast('Trial extendido y auditado.', { tono: 'exito' });
              await cargar(contenido, estadoVista);
            });
            return boton;
          },
        },
      ],
      filas: data ?? [],
    }),
  );
  destino.appendChild(
    crearPaginacion({
      total: count ?? 0,
      pagina: estadoVista.pagina,
      alCambiar: async (pagina) => {
        estadoVista.pagina = pagina;
        await cargar(contenido, estadoVista);
      },
    }),
  );
}
